class Sns {
  constructor() {
    this.triggers = document.querySelectorAll('.js-sns');
    this.init();
  }

  init() {
    if (!this.triggers.length) return;

    this.triggers.forEach((el) => {
      const type = el.dataset.sns;
      if (!type) return;

      el.addEventListener('click', (e) => {
        e.preventDefault();
        const url = encodeURIComponent(location.href);
        const text = encodeURIComponent(document.title);

        let shareUrl = '';
        switch (type) {
          case 'x':
            shareUrl = `https://x.com/intent/tweet?url=${url}&text=${text}`;
            break;
          case 'line':
            shareUrl = `https://social-plugins.line.me/lineit/share?url=${url}`;
            break;
        }

        if (shareUrl) {
          window.open(shareUrl, '_blank', 'noopener,noreferrer');
        }
      });
    });
  }
}

export default Sns;
